import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import SocialMediaButtons from '../components/SocialMediaButtons';

// CSS para animaciones
const styles = `
  @keyframes pulse-button {
    0%, 100% {
      transform: scale(1);
      box-shadow: 0 0 0 0 rgba(200, 120, 78, 0.7);
    }
    50% {
      transform: scale(1.03);
      box-shadow: 0 0 20px 10px rgba(200, 120, 78, 0.3);
    }
  }
`;

const InitialPage = () => {
  const videoRef = useRef(null);
  const navigate = useNavigate();
  const [contextMenu, setContextMenu] = useState({ show: false, x: 0, y: 0, type: null });
  const [copied, setCopied] = useState(false);
  const longPressTimer = useRef(null);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Detect if mobile
    const checkMobile = () => {
      setIsMobile(/iPhone|iPad|iPod|Android/i.test(navigator.userAgent));
    };
    checkMobile();
    
    // Close context menu on click outside
    const handleClickOutside = () => {
      setContextMenu({ show: false, x: 0, y: 0, type: null });
    };
    document.addEventListener('click', handleClickOutside);
    
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (videoRef.current) {
      const video = videoRef.current;
      
      // Force load the video
      video.load();
      
      const playVideo = async () => {
        try {
          await video.play();
          console.log('Video playing successfully');
        } catch (err) {
          console.log('Autoplay prevented:', err);
          // Retry after user interaction or delay
          setTimeout(async () => {
            try {
              await video.play();
              console.log('Video playing on second attempt');
            } catch (e) {
              console.log('Second attempt failed:', e);
            }
          }, 1500);
        }
      };
      
      // Listen for video ready state
      video.addEventListener('loadeddata', () => {
        console.log('Video data loaded');
        playVideo();
      });
      
      // Handle errors
      video.addEventListener('error', (e) => {
        console.error('Video error:', e);
      });
      
      playVideo();
    }
  }, []);

  const handleNavigation = (path) => {
    navigate(path);
  };

  // Right-click handler (Desktop)
  const handleContextMenu = (e, type) => {
    e.preventDefault();
    setContextMenu({
      show: true,
      x: e.clientX,
      y: e.clientY,
      type: type
    });
  };

  // Long press handlers (Mobile)
  const handleLongPressStart = (e, type) => {
    if (isMobile) {
      longPressTimer.current = setTimeout(() => {
        const touch = e.touches[0];
        setContextMenu({
          show: true,
          x: touch.clientX,
          y: touch.clientY,
          type: type
        });
      }, 600); // 600ms for long press on mobile
    }
  };

  const handleLongPressEnd = () => {
    if (longPressTimer.current) {
      clearTimeout(longPressTimer.current);
    }
  };

  const copyToClipboard = (type) => {
    const path = type === 'modelo' ? '/landing' : '/curso';
    const fullUrl = `${window.location.origin}${path}`;
    navigator.clipboard.writeText(fullUrl).then(() => {
      setCopied(true);
      setTimeout(() => {
        setCopied(false);
        setContextMenu({ show: false, x: 0, y: 0, type: null });
      }, 1500);
    });
  };

  const getLinkPath = (type) => {
    return type === 'modelo' ? '/landing' : '/curso';
  };

  return (
    <>
      <Helmet>
        <title>JG Models Agency | Agencia OnlyFans & Curso JGM University</title>
        <meta name="description" content="JG Models Agency - Agencia profesional de modelos OnlyFans. Postúlate como modelo o aprende a crear tu propia agencia con JGM University. Curso completo + acompañamiento." />
        <meta name="keywords" content="agencia onlyfans, modelos onlyfans, jg models, jgm university, curso onlyfans, agencia ofm, postular modelo onlyfans, chatters onlyfans" />
        
        <meta property="og:title" content="JG Models Agency | Agencia OnlyFans Profesional" />
        <meta property="og:description" content="Agencia profesional de modelos OnlyFans y curso JGM University para crear tu propia agencia." />
        <meta property="og:image" content="https://customer-assets.emergentagent.com/job_talentmgmt/artifacts/dyyu0c3k_Disen%CC%83o%20sin%20ti%CC%81tulo.png" />
        
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "JG Models Agency",
            "description": "Agencia profesional de modelos OnlyFans y formación especializada",
            "url": window.location.origin,
            "logo": "https://customer-assets.emergentagent.com/job_talentmgmt/artifacts/dyyu0c3k_Disen%CC%83o%20sin%20ti%CC%81tulo.png",
            "sameAs": [
              window.location.origin + "/landing",
              window.location.origin + "/curso"
            ],
            "contactPoint": {
              "@type": "ContactPoint",
              "contactType": "Customer Service",
              "availableLanguage": ["Spanish", "English"]
            }
          })}
        </script>
      </Helmet>

      <div>
        <style>{styles}</style>
        <div className="relative min-h-screen flex flex-col">
      {/* Background Video with Overlay */}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/70 z-10" />
        <video
          ref={videoRef}
          autoPlay
          loop
          muted
          playsInline
          webkit-playsinline="true"
          x5-playsinline="true"
          poster="https://customer-assets.emergentagent.com/job_talentmgmt/artifacts/1uka7rcz_IMG_6781.JPG"
          className="w-full h-full object-cover"
          preload="auto"
          style={{ willChange: 'auto' }}
        >
          <source src="https://customer-assets.emergentagent.com/job_16107709-b51d-40bf-8c9e-91360898709b/artifacts/ph1j8b94_video.mov" type="video/quicktime" />
          <source src="https://customer-assets.emergentagent.com/job_16107709-b51d-40bf-8c9e-91360898709b/artifacts/ph1j8b94_video.mov" type="video/mp4" />
        </video>
      </div>

      {/* Content */}
      <div className="relative z-20 flex flex-col min-h-screen">
        {/* Header with Logo and Access Buttons */}
        <header className="p-3 md:p-6 flex items-center justify-between bg-black/40 backdrop-blur-sm">
          <img 
            src="https://customer-assets.emergentagent.com/job_talentmgmt/artifacts/dyyu0c3k_Disen%CC%83o%20sin%20ti%CC%81tulo.png" 
            alt="JG Models Agency" 
            className="h-10 md:h-20 w-auto"
          />
          
          {/* Small Access Buttons - Top Right - Solo texto */}
          <div className="flex gap-3 md:gap-4">
            <button
              onClick={() => handleNavigation('/login')}
              className="text-[#c8784e] font-medium text-xs md:text-sm hover:text-[#d89a6f] transition-all duration-300"
            >
              Login
            </button>
            <button
              onClick={() => handleNavigation('/modelo')}
              className="text-white font-medium text-xs md:text-sm hover:text-gray-300 transition-all duration-300"
            >
              Modelos
            </button>
          </div>
        </header>

        {/* Main Content - 2 Large Buttons */}
        <main className="flex-1 flex items-center justify-center px-4">
          <div className="max-w-2xl w-full space-y-3 md:space-y-6">
            <h1 className="text-xl md:text-4xl lg:text-5xl font-bold text-white text-center mb-4 md:mb-12">
              Bienvenidos a JGM Agency
            </h1>
            
            <div className="space-y-2.5 md:space-y-4">
              {/* Botón Postúlate como Modelo */}
              <button
                onClick={() => handleNavigation('/landing')}
                onContextMenu={(e) => handleContextMenu(e, 'modelo')}
                onTouchStart={(e) => handleLongPressStart(e, 'modelo')}
                onTouchEnd={handleLongPressEnd}
                onTouchMove={handleLongPressEnd}
                className="w-full bg-[#c8784e] text-black px-4 py-2.5 md:px-8 md:py-6 rounded-lg md:rounded-xl font-semibold text-sm md:text-xl hover:bg-[#d89a6f] transition-all duration-300 hover:scale-110 hover:shadow-2xl hover:shadow-[#c8784e]/50 animate-pulse-subtle"
                style={{
                  animation: 'pulse-button 2s ease-in-out infinite'
                }}
              >
                Postúlate como Modelo
              </button>

              {/* Botón OFM University */}
              <button
                onClick={() => handleNavigation('/curso')}
                onContextMenu={(e) => handleContextMenu(e, 'university')}
                onTouchStart={(e) => handleLongPressStart(e, 'university')}
                onTouchEnd={handleLongPressEnd}
                onTouchMove={handleLongPressEnd}
                className="w-full bg-white/10 backdrop-blur-sm border border-white md:border-2 text-white px-4 py-2.5 md:px-8 md:py-6 rounded-lg md:rounded-xl font-semibold text-sm md:text-xl hover:bg-white hover:text-black transition-all duration-300 hover:scale-110 hover:shadow-2xl hover:shadow-white/50 animate-pulse-subtle"
                style={{
                  animation: 'pulse-button 2s ease-in-out infinite',
                  animationDelay: '0.5s'
                }}
              >
                OFM University
              </button>
            </div>
          </div>
        </main>

        {/* Footer */}
        <footer className="p-3 md:p-6">
          {/* Social Media */}
          <div className="mb-4">
            <p className="text-center text-sm text-gray-400 mb-3">Síguenos en nuestras redes</p>
            <SocialMediaButtons variant="fixed" adminWhatsApp={true} brandColors={true} />
          </div>
          
          {/* Copyright */}
          <p className="text-gray-400 text-xs md:text-sm text-center">
            © 2024 JG Models Agency. Todos los derechos reservados.
          </p>
        </footer>
      </div>

      {/* Context Menu - Appears on right-click (desktop) or long-press (mobile) */}
      {contextMenu.show && (
        <div
          className="fixed bg-black/95 backdrop-blur-sm border-2 border-[#c8784e] rounded-lg shadow-2xl z-[100] min-w-[250px]"
          style={{
            left: `${contextMenu.x}px`,
            top: `${contextMenu.y}px`,
            transform: 'translate(-50%, 10px)'
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="p-3">
            <p className="text-white text-xs font-medium mb-2 text-center">
              {copied ? '✅ Link copiado!' : 'Link directo'}
            </p>
            <div className="bg-gray-800 rounded p-2 mb-2">
              <p className="text-gray-300 text-xs break-all font-mono">
                {window.location.origin}{getLinkPath(contextMenu.type)}
              </p>
            </div>
            <button
              onClick={() => copyToClipboard(contextMenu.type)}
              className="w-full bg-[#c8784e] hover:bg-[#d89a6f] text-black px-4 py-2 rounded font-bold text-sm transition-all duration-300 flex items-center justify-center gap-2"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
              </svg>
              {copied ? 'Copiado' : 'Copiar Link'}
            </button>
          </div>
        </div>
      )}
      </div>
    </div>
    </>
  );
};

export default InitialPage;
